<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear planificación</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form ref="form" class="mt-3">
                        <v-row>
                            <v-col cols="12">
                                <v-btn
                                    color="red"
                                    class="white--text"
                                    @click="GoBack"
                                >
                                    Volver
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    :rules="required_val"
                                    v-model="planificacion.id_canal"
                                    :items="canales"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Canal"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    :rules="required_val"
                                    v-model="planificacion.id_tipo_pieza"
                                    :items="tipos_pieza"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Tipo de pieza"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="planificacion.precio"
                                    disabled
                                    label="Precio"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    :rules="required_val"
                                    v-model="planificacion.hora"
                                    label="Hora"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    :rules="required_val"
                                    v-model="planificacion.campana"
                                    label="Campaña"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12"><h3>Zonas Horarias</h3></v-col>
                            <v-col cols="6" md="4">
                                <v-checkbox
                                    v-model="planificacion.zonas_horarias.lvm"
                                    label="LVM"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-checkbox
                                    v-model="planificacion.zonas_horarias.lvt"
                                    label="LVT"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-checkbox
                                    v-model="planificacion.zonas_horarias.fdm"
                                    label="FDM"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-checkbox
                                    v-model="planificacion.zonas_horarias.fdt"
                                    label="FDT"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-checkbox
                                    v-model="
                                        planificacion.zonas_horarias.rotacion
                                    "
                                    label="Rotación"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="planificacion.observaciones"
                                    outlined
                                    label="Observaciones"
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="disponibles"
                                    disabled
                                    outlined
                                    label="Cantidad disponible"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-card>
                            <div>
                                <plan-picker
                                    :lv="
                                        planificacion.zonas_horarias.lvm ||
                                        planificacion.zonas_horarias.lvt ||
                                        planificacion.zonas_horarias.rotacion
                                    "
                                    :fd="
                                        planificacion.zonas_horarias.fdm ||
                                        planificacion.zonas_horarias.fdt ||
                                        planificacion.zonas_horarias.rotacion
                                    "
                                    @update="calcDisponibles()"
                                    :disponibles="disponibles"
                                    :maxReached="disponibles > 0"
                                    v-model="planificacion.fechas"
                                >
                                </plan-picker>
                            </div>
                        </v-card>
                        <v-row>
                            <v-col cols="12">
                                <v-btn
                                    v-if="!planificacion.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    @click="savePlanificacion"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-else
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    @click="UpdatePlanificacion"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    @click="GoBack"
                                    >Cancelar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            required_val: [(v) => !!v || "El campo es requerido"],
            producto: null,
            registrados: 0,
            utilizados: 0,
            utilizados_local: 0,
            disponibles: 0,
            rol: 0,
            canales: [
                { nombre: "Tv", id: 1 },
                { nombre: "Radio", id: 2 },
                { nombre: "Web", id: 3 },
            ],
            tipos_pieza: [
                { nombre: "Cuña", id: 1 },
                { nombre: "Spot", id: 2 },
                { nombre: "Banner", id: 3 },
            ],

            headers: [
                { text: "Producto", value: "producto", sortable: false },
                { text: "Origen", value: "cantidad", sortable: false },
                { text: "Hasta la fecha", value: "todo", sortable: false },
                { text: "Resta", value: "todo", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            planificacion: {
                campana: null,
                id_linea: null,
                id_contrato: null,
                id_canal: null,
                id_tipo_pieza: null,
                observaciones: "",
                zonas_horarias: {
                    lvm: false,
                    lvt: false,
                    fdm: false,
                    fdt: false,
                    rotacion: false,
                },
                matricula: null,
                precio: null,
                hora: null,
                fechas: [],
            },
            productos: [],

            linea: {},
        };
    },
    watch: {
        "planificacion.fechas": function (val) {
            this.calcDisponibles();
        },
    },
    created() {
        this.rol = localStorage.getItem("role");

        if (this.$route.query.id) {
            //console.log("cliente");
            this.getLinea(this.$route.query.id);
        }
        if (this.$route.query.id_plan) {
            this.getPlanificacion(this.$route.query.id_plan);
        }
    },
    methods: {
        calcUtilizados() {
            let cantidad = 0;
            this.planificacion.fechas.forEach((element) => {
                cantidad += parseFloat(element.cantidad);
            });

            this.utilizados_local = cantidad;
            return cantidad;
        },
        calcDisponibles() {
            this.planificacion.precio =
                this.producto.precio * this.calcUtilizados();
            this.disponibles =
                this.registrados - this.utilizados - this.utilizados_local;
            //console.log(`disponibles: ${this.disponibles}`);
        },
        createCantidadRange() {},
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        getLinea(id) {
            this.planificacion.id_linea = id;
            axios.get(`api/GetLineaContrato/${id}`).then(
                (res) => {
                    this.planificacion.id_contrato = res.data.id_contrato;
                    this.linea = res.data;
                    this.registrados = this.linea.cantidad;
                    this.utilizados =
                        this.linea.utilizado - this.calcUtilizados();
                    this.disponibles = this.registrados - this.utilizados;
                    this.producto = this.linea.producto;
                    //console.log(this.linea);
                },
                (res) => {}
            );
        },
        getPlanificacion(id) {
            this.planificacion.id_linea = id;
            axios.get(`api/get-planificacion/${id}`).then(
                (res) => {
                    let data = res.data.data;
                    this.planificacion.id = id;
                    this.planificacion.campana = data.campana;
                    this.planificacion.id_linea = data.id_linea;
                    this.planificacion.id_contrato = data.id_contrato;
                    this.planificacion.id_canal = data.id_canal;
                    this.planificacion.id_tipo_pieza = data.id_tipo_pieza;
                    this.planificacion.observaciones = data.observaciones;
                    (this.planificacion.zonas_horarias = {
                        lvm: data.zona_horaria.lvm,
                        lvt: data.zona_horaria.lvt,
                        fdm: data.zona_horaria.fdm,
                        fdt: data.zona_horaria.fdt,
                    }),
                        (this.planificacion.matricula = data.matricula);
                    this.planificacion.precio = data.precio;
                    this.planificacion.hora = data.hora;
                    let fechas = [];
                    data.fechas.forEach((element) => {
                        fechas.push({
                            id: element.id,
                            fecha: moment(element.fecha),
                            cantidad: element.cantidad,
                        });
                    });
                    this.planificacion.fechas = fechas;
                    this.getLinea(data.id_linea);
                    //console.log(this.planificacion);
                },
                (res) => {}
            );
        },
        GoBack() {
            this.$router.push(
                `ver-planificacion?id=${this.planificacion.id_contrato}`
            );
        },
        savePlanificacion(id) {
            if (!this.$refs.form.validate()) return;
            let planificacion = JSON.parse(JSON.stringify(this.planificacion));
            planificacion.fechas.forEach((element) => {
                element.fecha = moment(element.fecha).format("yyyy-MM-DD");
                //console.log(element);
            });
            axios
                .post(`api/save-planificacion`, planificacion)
                .then((res) => {
                    this.GoBack();
                })
                .catch((error) => {
                    /////console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        UpdatePlanificacion() {
            let planificacion = JSON.parse(JSON.stringify(this.planificacion));
            planificacion.fechas.forEach((element) => {
                element.fecha = moment(element.fecha).format("yyyy-MM-DD");
                //console.log(element);
            });
            axios.post(`api/update-planificacion`, planificacion).then(
                (res) => {
                    this.GoBack();
                },
                (res) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
div[aria-required="true"].v-input .v-label::after {
    content: " *";
    color: red;
}
</style>
